import { render } from "./Questionarios.vue?vue&type=template&id=af46a18e"
import script from "./Questionarios.vue?vue&type=script&lang=js"
export * from "./Questionarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__